import React, { useEffect } from 'react'
import { BodyText, InvestmentColTwoSpanReverse, LeftColSection, RightColSection } from '../investment/Investment.styles'
import { LeftSection, RightSection, SavingsHeader, SavingsWrapper } from '../savingsStage/SavingsStage.styles'

export const LongTermSavings = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <SavingsWrapper>
         <SavingsHeader>
            <LeftSection>
            <h3>
                Long term target goal Savings
                Smartly designed to make
                Hitting massive target goals seamlessly possible
            </h3>
            </LeftSection>
            <RightSection>
                <img src="img/NA_October_14-ai 1.svg" alt="Group of people playing dart game" />
            </RightSection>
        </SavingsHeader>
        <InvestmentColTwoSpanReverse>
        <LeftColSection>
          <BodyText>
                This plan enables you save consistently towards a bigger 
                target like buying a Laptop or a car e.t.c  It’s been 
                premeditatedly designed to spur you into an earnest and 
                determined savings habit, you are required to activate 
                with a sum of #100,000 to commit you into constant savings 
                towards hitting your target goal. for instance, you want to 
                save to buy an apple laptop worth over #1M or a car of #3M 
                then starting with #100,000 will be a smart push for you. 
                It can be activated for you, activated by you and you can 
                activate for someone else while you benefit off a benefactor 
                to get more funds and as well receive fund transfer directly 
                into the Savings plan to hit your target goals easily with speed.

          </BodyText>
        </LeftColSection>
        <RightColSection>
            <img src="img/Layer 1.svg" alt="humaan hands carrying a bag of money" />
        </RightColSection>
      </InvestmentColTwoSpanReverse>
    </SavingsWrapper>

  )
}
